import I18nPlugin from './index';

export const I18nService = new I18nPlugin();
